/**
 * The images on a Feedback record (feedback quick capture spec 01 §5): read off the record, in order. The record
 * carries each image's auth-gated `download_href`; the web shell fetches the bytes with the person's sign-in.
 */
import type { RecordView } from "./object-ui/contract";

export interface FeedbackRecordImage {
  imageId: string;
  filename: string;
  mediaType: string;
  /** The API path that serves the bytes; it needs the person's sign-in. */
  downloadHref: string;
}

/** The images on a Feedback record, or an empty list when it carries none. */
export function feedbackImagesOf(record: RecordView): FeedbackRecordImage[] {
  const rows = record["images"];
  if (!Array.isArray(rows)) return [];
  return rows.flatMap((row): FeedbackRecordImage[] => {
    if (typeof row !== "object" || row === null) return [];
    const { image_id, filename, media_type, download_href } = row as Record<
      string,
      unknown
    >;
    if (
      typeof image_id !== "string" ||
      typeof download_href !== "string" ||
      !download_href
    ) {
      return [];
    }
    return [
      {
        imageId: image_id,
        filename: typeof filename === "string" ? filename : "image",
        mediaType: typeof media_type === "string" ? media_type : "image/png",
        downloadHref: download_href,
      },
    ];
  });
}
